export default "__VITE_ASSET__ChJ8mfy8__"